import { resetOperation } from '../redux/operationSlice';

/**
 * Reusable escape key handler utility for drawing operations
 * Handles cleanup of temporary objects, snap markers, and input buffers
 */
export const createEscapeHandler = (options = {}) => {
  const {
    scene,
    dispatch,
    tempObjectRef,
    snapMarkerRef,
    inputBuffer,
    inputText,
    additionalCleanup = () => {},
    resetOpOnEscape = true
  } = options;

  return (e) => {
    if (e.key === 'Escape' || (options.includeSpace && e.key === ' ')) {
      // Clear input text if available
      if (inputText) {
        inputText.clear();
      }

      // Remove and dispose temporary object
      if (tempObjectRef?.current) {
        scene.remove(tempObjectRef.current);
        if (tempObjectRef.current.geometry) {
          tempObjectRef.current.geometry.dispose();
        }
        if (tempObjectRef.current.material) {
          tempObjectRef.current.material.dispose();
        }
        tempObjectRef.current = null;
      }

      // Remove and dispose snap marker
      if (snapMarkerRef?.current) {
        scene.remove(snapMarkerRef.current);
        if (snapMarkerRef.current.geometry) {
          snapMarkerRef.current.geometry.dispose();
        }
        if (snapMarkerRef.current.material) {
          snapMarkerRef.current.material.dispose();
        }
        snapMarkerRef.current = null;
      }

      // Clear input buffer
      if (inputBuffer?.current !== undefined) {
        inputBuffer.current = '';
      }

      // Run additional cleanup function
      additionalCleanup();

      // Reset operation if requested
      if (resetOpOnEscape && dispatch) {
        dispatch(resetOperation());
      }
    }
  };
};

/**
 * Hook version for easier integration with React components
 */
export const useEscapeHandler = (options) => {
  return createEscapeHandler(options);
};